// extracted by mini-css-extract-plugin
export default {"menu":"GraphicEditorTooltip_menu__I--em","menuWrapper":"GraphicEditorTooltip_menuWrapper__L4Mta","button":"GraphicEditorTooltip_button__B7bcc"};